export default `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28"><circle class="colorize" cx="14.175" cy="14.175" r="14.173"/></svg>`;